<button *ngIf="type=='button'" pButton type="button" class="ey-button me-2 mt-0 download-focus-tab"(keyup.enter)="handleTabfocusAction.onEnterKey($event)" (click)="downloadFile()" tabindex="0" aria-label="download">
  <span *ngIf="displayDownloadIcon" class="pi pi-download me-1"></span> {{btnName}}</button>
<a *ngIf="type=='anchor' && valid" tabindex="0" class="download-focus-tab" [ngClass]= "{'download-disabled' : disableClass === true}" (keyup.enter)="handleTabfocusAction.onEnterKey($event)" (click)="checkReportCateg($event)" aria-label="Download"><i class="me-2" class="pi pi-download"></i></a>

<div *ngIf="type=='split-btn'" class="download-split">
  <button pButton pRipple type="button" tabindex="0" class="ey-button-dark me-2 mt-0 download-focus-tab" (keyup.enter)="handleTabfocusAction.onEnterKey($event)" (click)="menu.toggle($event)" aria-label="Download">{{btnName}}
    <i class="me-2" class="pi pi-angle-down"></i>
  </button>
  <p-menu #menu [popup]="true" [model]="splitDownloadItems"></p-menu>
</div>

<p-dialog header="{{'text.downloadStatus' | translate}}" [(visible)]="displayInvalidDialog" [modal]="true" [style]="{width: '50vw'}">
    <div class="row">
      <label>{{validationMessage}}</label>
    </div>
    <p-footer>
      <button pButton aria-label="okay"(keyup.enter)="handleTabfocusAction.onEnterKey($event)" (click)="closeErrorDialog()" class="ey-secondary-dark me-2 mt-0 download-focus-tab" tabindex="0">{{'text.okay' | translate}}</button>
    </p-footer>
  </p-dialog>
